import Vue from 'vue'
import Vuex from 'vuex'

// # modules
import app from '@/store/modules/app'
import system from '@/store/modules/system'
import resource from '@/store/modules/resource'
import user from '@/store/modules/user'
import subscription from '@/store/modules/subscription'
import subscriptionRelated from '@/store/modules/subscriptionRelated'
import dashboard from '@/store/modules/dashboard'
import createApp from '@/store/modules/createApp'
import iconGallery from '@/store/modules/iconGallery'
import notificationStore from '@/store/modules/notificationStore'
import orderService from '@/store/modules/orderService'
import createEmulatorPlugin from '@/plugins/Emulator'
import userManagement from '@/store/modules/userManagement'
import radioStream from '@/store/appModules/radioSteram'
import rssfeed from '@/store/appModules/rssfeed'
import team from '@/store/appModules/team'
import facebook from '@/store/appModules/facebook'
import twitter from '@/store/appModules/twitter'
import website from '@/store/appModules/website'
import textContent from '@/store/appModules/textContent'
import imageGallery from '@/store/modules/imageGallery'
import imageGalleryModule from '@/store/appModules/imageGalleryModule'
import analytics from '@/store/modules/analytics'
import publish from '@/store/modules/appPublishing'
import formModule from '@/store/appModules/formModule'
import feedback from '@/store/modules/FeedbackService'
import youtube from '@/store/appModules/youtube'
import instagram from '@/store/appModules/instagram'
import chat from '@/store/appModules/chat'
import customCode from '@/store/appModules/customCode'
import pdfModule from '@/store/appModules/pdfModule'
Vue.use(Vuex)

Vue.use({
  install (Vue, parameters) {
    Vue.prototype.$showLoader = function () {
      this.$store.dispatch('showLoader')
    }
    Vue.prototype.$hideLoader = function () {
      this.$store.dispatch('hideLoader')
    }
  }
})

export default new Vuex.Store({
  plugins: [createEmulatorPlugin()],
  modules: {
    app,
    system,
    resource,
    user,
    subscription,
    subscriptionRelated,
    dashboard,
    createApp,
    iconGallery,
    notificationStore,
    orderService,
    userManagement,
    radioStream,
    team,
    facebook,
    twitter,
    textContent,
    imageGallery,
    imageGalleryModule,
    analytics,
    publish,
    formModule,
    feedback,
    youtube,
    website,
    rssfeed,
    chat,
    instagram,
    customCode,
    pdfModule
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js